module.exports = __webpack_public_path__ + "img/dengji4.931cae73.png";